export default "__VITE_ASSET__C_dy7gV1__"